export const handleCopy = (textToCopy: string) => {
  const tempTextArea = document.createElement("textarea");
  tempTextArea.value = textToCopy;
  document.body.appendChild(tempTextArea);

  tempTextArea.select();
  document.execCommand("copy");

  document.body.removeChild(tempTextArea);
};

export const capitalize = (s: unknown) => {
  if (typeof s !== "string") {
    return "";
  }
  return s.charAt(0).toUpperCase() + s.slice(1);
};

export const stringSearch = (str?: string, query?: string): boolean => {
  if (!str || !query) {
    return false;
  }

  const lowerStr = str.toLowerCase();
  const lowerQuery = query.toLowerCase();

  return lowerStr.includes(lowerQuery);
};
